/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
  HStack,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom"; // ← add this
import ContentPanel from "../../Components/SampleDataPage/ContentPanel";
// import { DataSampleSections } from "../../Components/SampleDataPage/mockData";
import SearchableSidebar from "../../Components/SampleDataPage/SearchableSidebar";
import SectionCardsPanel from "../../Components/SampleDataPage/SectionCardsPanel";
import LoadingSpinner from "../../LoadingSpinner";
import apiClient from "../../utils/ApiClient/apiClientAxios";

const HealthTopicsLayout = () => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const [searchParams, setSearchParams] = useSearchParams(); // ← add this
  const [healthSections, setHealthSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [viewMode, setViewMode] = useState("cards");
  const [breadcrumbs, setBreadcrumbs] = useState([
    { name: "Home", href: "#" },
    { name: "Monitor", href: "#" },
  ]);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get("/getData");
        const data = response.data;
        setHealthSections(data);
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (healthSections.length === 0) return;
    const tabParam = searchParams.get("tab");
    const matchedSection = tabParam
      ? healthSections.find(
          (s) => s.title.toLowerCase() === tabParam.toLowerCase(),
        )
      : null;

    const sectionToActivate = matchedSection || healthSections[0];
    setActiveSection(sectionToActivate);
    updateBreadcrumbsForSection(sectionToActivate);
  }, [healthSections]); 

  const handleSectionClick = (section) => {
    setActiveSection(section);
    setActiveItem(null);
    setViewMode("cards");
    updateBreadcrumbsForSection(section);
    // ← keep URL in sync
    setSearchParams({ tab: section.title });
  };

  const handleItemClick = (item) => {
    setActiveItem(item);
    setViewMode("detail");
    updateBreadcrumbsForItem(item);
  };

  const handleBackToCards = () => {
    setActiveItem(null);
    setViewMode("cards");
    if (activeSection) {
      updateBreadcrumbsForSection(activeSection);
    }
  };

  const updateBreadcrumbsForSection = (section) => {
    setBreadcrumbs([
      { name: "Home", href: "#" },
      { name: "Monitor", href: "#" },
      { name: section.title, href: "#", isCurrentPage: true },
    ]);
  };

  const updateBreadcrumbsForItem = (item) => {
    const section = healthSections.find((s) =>
      s.items.some((i) => i.id === item.id),
    );
    setBreadcrumbs([
      { name: "Home", href: "#" },
      { name: "Monitor", href: "#" },
      ...(section
        ? [
            {
              name: section.title,
              href: "#",
              onClick: () => handleSectionClick(section),
            },
          ]
        : []),
      { name: item.title, href: "#", isCurrentPage: true },
    ]);
  };

  if (loading) return <LoadingSpinner />;

  return (
    <Box minH="100vh" bg="gray.50">
      <Box bg="white" borderBottom="1px" borderColor="gray.200" py={3}>
        <Box mx={5}>
          <Breadcrumb fontSize="sm" color="blue.600">
            {breadcrumbs.map((crumb, index) => (
              <BreadcrumbItem key={index} isCurrentPage={crumb.isCurrentPage}>
                <BreadcrumbLink
                  href={crumb.href}
                  onClick={crumb.onClick}
                  color={crumb.isCurrentPage ? "gray.600" : "blue.600"}
                  fontWeight={crumb.isCurrentPage ? "semibold" : "normal"}
                  cursor={crumb.onClick ? "pointer" : "default"}
                >
                  {crumb.name}
                </BreadcrumbLink>
              </BreadcrumbItem>
            ))}
          </Breadcrumb>
        </Box>
      </Box>

      <Container maxW="1680px">
        <HStack align="stretch" spacing={0}>
          {viewMode === "cards" ? (
            <SectionCardsPanel
              section={activeSection}
              onItemClick={handleItemClick}
              activeItemId={activeItem?.id}
            />
          ) : (
            <ContentPanel content={activeItem} onBack={handleBackToCards} />
          )}

          <SearchableSidebar
            sections={healthSections}
            onSectionClick={handleSectionClick}
            onItemClick={handleItemClick}
            activeSectionId={activeSection?.title}
            activeItemId={activeItem?.id}
            isOpen={isOpen}
            onToggle={onToggle}
          />
        </HStack>
      </Container>
    </Box>
  );
};

export default HealthTopicsLayout;
